// VCIN Brand: Always use VCIN_COLORS from constants.js - never use Tailwind blue classes
import React from 'react';
import { Outlet, useNavigate } from 'react-router-dom';
import SuperAdminSidebar from './SuperAdminSidebar';
import { LogOut } from 'lucide-react';
import { useAuth } from '../../context/AuthContext';
import { VCIN_COLORS } from '../../styles/constants';

export default function SuperAdminLayout() {
  const { user } = useAuth();
  const navigate = useNavigate();

  return (
    <div className="min-h-screen" style={{ backgroundColor: '#F5F6F8' }}>
      <SuperAdminSidebar />
      
      {/* Main content area */}
      <div className="ml-64">
        {/* Top header */}
        <header 
          className="sticky top-0 z-10 h-16 px-8 flex items-center justify-between border-b"
          style={{ backgroundColor: 'white', borderColor: '#E5E7EB' }}
        >
          <div />
          <div className="flex items-center gap-4">
            <div className="text-right">
              <p className="text-sm font-medium text-gray-900">{user?.email}</p>
              <p className="text-xs text-gray-500">Platform Administrator</p>
            </div>
            <div
              className="w-10 h-10 rounded-full flex items-center justify-center text-white font-semibold"
              style={{ backgroundColor: VCIN_COLORS.gold }}
            >
              SA
            </div>
            <button
              onClick={() => navigate('/signout')}
              className="flex items-center gap-2 px-3 py-2 rounded-lg text-sm font-medium text-gray-500 hover:text-red-600 hover:bg-red-50 transition-colors"
              data-testid="sa-header-logout-btn"
              title="Sign Out"
            >
              <LogOut className="w-4 h-4" />
              Sign Out
            </button>
          </div>
        </header>

        {/* Page content */}
        <main className="p-8">
          <Outlet />
        </main>
      </div>
    </div>
  );
}
